import * as React from 'react';
import { Select } from '@app/src/components/Select';
import { Field } from '@app/src/components/Field';

export const RenderSelect = ({
  options,
  label,
  placeholder,
  meta: { error, touched },
  input,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  return(
    <Field label={label} errorMessage={isError}>
      <Select
        selected={input.value}
        placeholder={placeholder}
        uncontrolled
        {...input}
        {...rest}
        error={!!isError}
        options={options}
      />
    </Field>
  );
};
